<template>
  <div class="page">
      <img class="logo" src="logo.png">
      <br>
        <span class="search_wrapper">
        <v-autocomplete
          :items="items"
          v-model="item"
          :get-label="getLabel"
          :component-item="template"
          :min-len="2"
          @update-items="updateItems"
          @keyup="test"
        ></v-autocomplete>
      </span>
  </div>
</template>

<script>
// @ is an alias to /src
import ItemTemplate from "../components/ItemTemplate.vue";
import axios from "axios";

export default {
  data() {
    return {
      item: null,
      items: [],
      template: ItemTemplate
    };
  },
  mounted: function(){
    const el = document.querySelector('.v-autocomplete-input')
    const that = this
    el.addEventListener('keyup', e => {
      if(e.keyCode == 13){
        window.query = `${e.target.value}`
        that.$router.push({name:'about'})
      }
    })
    el.focus()
  },
  methods: {
    getLabel(item) {
      return item ? item.name : "";
    },
    updateItems(text) {
      this.fetchFromElastic(text).then(response => {
        if (response.status == 200) {
          this.items = this.convertList(response);
        }
      });
    },
    fetchFromElastic(txt) {
      return axios.post(
        "https://api.snhyun.me:8881/autocompletion/_search",
        {
          query: {
            term: {
              "content.keyword_prefix": `${txt}`
            }
          },
          highlight: {
            fields: {
              "content.keyword_prefix": {}
            }
          }
        },
        { headers: { "Content-Type": "application/json" } }
      );
    },
    convertList(res) {
      debugger;
      return res.data.hits.hits.map(r => ({ 
        html: r.highlight['content.keyword_prefix'][0],
        name: r._source.content 
      }));
    },
    test(){
      debugger;
    }
  }
}




</script>

<style lang="css">



.v-autocomplete-input {
  border: 4px solid #6441a4;
  margin: 10px;
  width: 400px;
  height: 45px;
  outline: 0;
  background-color: transparent;
  color: #6441a4;
  font-weight: 700;
  font-size: 18px;
  line-height: 23px;
  padding: 2px 2px 2px 10px;
}

.page {
  padding-top: 20vh;
  text-align: center;
  padding-bottom: 20px;
  margin-bottom: 25vh;
}

.logo {
  padding-bottom: 15px;
}

.search {
  width: 45vw;
  padding: 8px;
  border: 1px solid #d9d9d9;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACrElEQVR42u2Xz2sTQRSAX8VSb1K8iNqKooJH2Ux6Ksn+iPQqxZMIehJB0do/IMhmQWsvHr2KSEGk0tSLIoWIYNUKij20F2/N7iaUZnYT0kYzzhMKs0HDJiTdLcwHDwKZSd63781LBiQSSW9JZdkhzfKm1Rz9mjZp/W9YdEU3vXv4HsQZ40FtNG36q5rls//Ej4tmbSS2T15Mvp3ExOPmEMQNbBtMMEyoljcFcQN7PqyAlqNfIG7gYQ0tYNIaxA1MrJPY3wImbUqBKAXSFv0tBSIVMOkvKRDtGKWN/T6FdqRAxFNoWwpEPIXqUqBT6ALU/UVgu8GW4GD3f6f9TRDYNJTDrk7YbtiqUumHwIYoUJuHERDAS0r4CvgFECgbY+cFAR7KT+g1POmCKFDNw6WggHc3fBtVb4CAoyauBgXIG+g1Xh5mRAGah6cggBd11fK/h7lOprIs0H6uRl6KAo5O7kOv4QmPiwJ4Jqqv4FiwCtXjvD2+tRmfK6kZ/ygI2HritK0rDVGgrClJ6DWMwYC/AGuCBMYcIC2V0CzvjmbRz3j3xUjn6CfeYreUJ2wQkGD75INPX1mFfsEFrrcIYCvdhC4paWQakxajpJMr0C9YFg54i7AsClRmh9/xnr0NHcInzZStk2aLwAcGMAD9pPIazvFKVDD5rdnhJeHLX5RTyRPQHpz5o66emMc9wdlPtvA8wF7Aq2BUHh1525qEo5JtR1WeOXpickO9cJIpyuD6xJmhYiZ5ytWSl3mlnuOaf+2zDaLDXmJrSgZ/MYVEugo+gSh+FkSBa4yd5Ul87DZ5XpFl/AyIEjzYjkau8WqshU2cr13HPbgX4gJOD97n465GZlyVvC9mSKloKI2iTnbwNT+gBX54H+IaXAtxJzE3ycSAFqSAFJACUkAikXD+AHj5/wx2o5osAAAAAElFTkSuQmCC) no-repeat;
  background-position: 98.5%;
  background-size: 1.5em;
}

.search:hover {
  border: 1px solid #b9b9b9;
  border-top-color: #a0a0a0;
}

.search:focus {
  outline: none;
  border: 1px solid #4d90fe;
}

.Bcontainer {
  text-align: center;
  margin: 0 auto;
  width: 270px;
  padding-top: 20px;
}

.button {
  display: inline-block;
  background: #f2f2f2;
  padding: 8px 12px;
  font-weight: 700;
  font-size: 13px;
  border: 1px solid #f2f2f2;
  border-radius: 2px;
  color: #757575;
  font-family: arial, sans-serif;
}

.button:hover {
  border: 1px solid #c6c6c6;
  color: #222;
  cursor: default;
}

.left {
  float: left;
}

.nav > li > a {
  padding: 0;
  color: #000;
  opacity: .75;
}

.nav > li > .colorfix {
  opacity: 1;
}

.nav>li>a:hover,
.nav>li>a:visited,
.nav>li>a:focus {
  background-color: white;
  text-decoration: underline;
}

.nav-pills {
  margin: 15px 5px;
}

.nav li {
  float: right;
  margin-right: 15px;
}

.firstsbuttons {
  margin-top: 4.5px;
}

.btn,
.btn:active {
  color: white;
  font-weight: 700;
  background: -webkit-linear-gradient(top, #4387fd, #4683ea);
  padding: 4px 10.5px;
  border: 1px solid #4285f4;
  border-radius: 2px;
  font-size: 13px;
}

.btn.focus,
.btn:focus,
.btn:hover,
.btn:visited,
.btn:active {
  color: white;
  cursor: default;
}

.nav>li>a>img {
  opacity: .75;
}

.nav>li>a>img:hover {
  opacity: 1;
  cursor: default;
}


</style>
